module.exports = __webpack_public_path__ + "img/footer.d5a2ce5e.svg";